if (!customElements.get('form-checkbox')) {
  customElements.define('form-checkbox', class ProductForm extends HTMLElement {
    constructor() {
      super();
      this.checkbox = this.querySelector('[type=checkbox]');
      this.priceSelectors = [
        'sticky-bar [data-price]',
        'sticky-bar [data-sale-price]',
        'sticky-bar [data-referral-price]'
      ];
      this.priceObj = {
        airFilterPrice: +this.checkbox?.dataset?.airFilterPrice,
        originalPrice: +this.checkbox?.dataset?.price,
        totalPrice: +this.checkbox?.dataset?.finalPrice,
        referralPrice: +(document.querySelector(`${this.priceSelectors[2]}`)?.dataset?.referralPrice || 0)
      }
      if (this.checkbox) {
        this.checkbox.addEventListener("change", this.onChangeHandler.bind(this));
        document.addEventListener("DOMContentLoaded", this.syncCheckboxes.bind(this));
      }
    }

    syncCheckboxes(){
      this.updatePrice();
      const allCheckboxes = document.querySelectorAll(`${this.tagName}`);
      if (!allCheckboxes.length) return;

      const checkedCheckbox = [...allCheckboxes].some(element => element.checkbox.checked);
      if(checkedCheckbox){
        allCheckboxes.forEach(element => (element.checkbox.checked = true));
      }
    }

    updatePrice(element = this) {
      const { checkbox } = element;
      const priceElements = document.querySelectorAll(element.priceSelectors.join(','));

      const { airFilterPrice, originalPrice, totalPrice, referralPrice } = element.priceObj;

      if (!priceElements.length || !totalPrice || !originalPrice) return;

      const finalAirFilterPrice = checkbox.checked === true  ? airFilterPrice : 0;

      priceElements.forEach(price => {
        let displayPrice = null;
        if (price.dataset.referralPrice) {
          displayPrice = referralPrice;
        } else if (price.dataset.salePrice) {
          displayPrice = totalPrice;
        } else {
          displayPrice = originalPrice;
        }
        price.innerText = Shopify.formatMoney(displayPrice + finalAirFilterPrice);
      });
    }

    onChangeHandler(event) {
      event.preventDefault();
      const allCheckboxes = document.querySelectorAll(`${this.tagName}`);
      if (!allCheckboxes.length) return;
      allCheckboxes.forEach(element => {
        if (element !== this) {
          element.checkbox.checked = event.target.checked;
        };
        this.updatePrice(element);
      })
    }
  });
}
